import CheckboxDropdown from '../../../../../Components/Form/Inputs/CheckboxDropdown';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import { endorsementLengthOptions, LiquidityRiskCalculationInputs } from '../../../RiskDefinitions';
import styles from '../../InsuranceQuoteEstimator.module.scss';

interface ILiquidityRiskEndorsementLengthDropdownProps {
    calculationInputs: LiquidityRiskCalculationInputs;
    setCalculatorInputs: (value: LiquidityRiskCalculationInputs) => void;
}

const minimumSelectionLimit = 1;

const LiquidityRiskEndorsementLengthDropdown: React.FC<ILiquidityRiskEndorsementLengthDropdownProps> = (
    props: ILiquidityRiskEndorsementLengthDropdownProps,
) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.liquidity_risk_section}>
            <CheckboxDropdown
                labelType="selectedTextValues"
                minimumSelectionLimit={minimumSelectionLimit}
                label={translations.risk.margin.fields.endorsementLength}
                values={props.calculationInputs.endorsementLength}
                options={endorsementLengthOptions}
                handleOptionSelect={(value) => props.setCalculatorInputs({ ...props.calculationInputs, endorsementLength: value })}
                track={{
                    eventCategory: 'InsuranceQuoteEstimator',
                    eventAction: 'LivestockEndorsementLengthChanged',
                    eventValue: props.calculationInputs?.endorsementLength,
                }}
            />
        </div>
    );
};

export default LiquidityRiskEndorsementLengthDropdown;
